<template>
  <div class="coupon responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'coupons', label: 'Coupon' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "coupons",
  data() {
    return {
      listPageHeader,
      entity: Entities.COUPON,
    };
  },
  mounted: function () {
    this.setPageTitle("Coupon");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "couponModule/sort",
      pagination: "couponModule/pagination",
      initialFilter: "couponModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "couponModule/updateSort",
      updatePagination: "couponModule/updatePagination",
      updateInitialFilter: "couponModule/updateInitialFilter"
    }),
  }
};
</script>
